import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
const root = ReactDOM.createRoot(document.getElementById('root'));
// DEV ONLY (upstox-036): ?riskHarness=<state> renders the Risk Terminal from a
// fixture, without login, for screenshots. The production build drops this
// branch (NODE_ENV is a build-time constant), so the harness never ships.
if (process.env.NODE_ENV === 'development' && new URLSearchParams(window.location.search).has('riskHarness')) {
  const RiskHarness = require('./components/riskTerminal/dev/RiskHarness').default;
  root.render(<RiskHarness />);
} else if (window.location.hash === '#upstox-signed-in') {
  // upstox-053: the Upstox sign-in tab lands here, tells the other tabs, closes
  const UpstoxSignedIn = require('./components/riskTerminal/UpstoxSignedIn').default;
  root.render(<UpstoxSignedIn />);
} else {
  root.render(<React.StrictMode><App /></React.StrictMode>);
}

// Register service worker for PWA install + offline shell
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
